import { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

/** Components */
import Login from "../pages/auth/Login";
import Layouts from "../layouts/Layouts";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../pages/notFound/NotFound";
import ResetPassword from "../pages/resetPassword/ResetPassword";
import ReportAccess from "../pages/Reports/ReportAccess";
import AuthorizedRoute from "./AuthorizedRoutes";
import ForgotPassword from "../pages/forgotPassword/ForgotPassword";

const PublicCandidateAssessment = lazy(() => import("../pages/candidateAssessment/publicCandidateAssessment/PublicCandidateAssessment"));

const AppRoutes = (props) => {
  return (
    <Router>
      <Suspense
        fallback={
          <div>
            <div>Loading...</div>
          </div>
        }
      >
        <Routes>
          <Route
            name="Layout"
            path="/"
            element={
              <ProtectedRoute>
                <Layouts componentRoutes={props.componentRoutes.filter(r => !r.isFullScreen)} />
              </ProtectedRoute>
            }
          >
            {props.componentRoutes.filter(r => !r.isFullScreen).map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <AuthorizedRoute
                    component={route.component}
                    securityKey={route.securityKey}
                  />
                }
              />
            ))}

            <Route path="report/:reportName" element={<ReportAccess />} />
            <Route path="*" name="Not Found" element={<NotFound />} />
          </Route>

          {/* Full Screen Routes */}
          {props.componentRoutes.filter(r => r.isFullScreen).map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedRoute>
                  <AuthorizedRoute
                    component={route.component}
                    securityKey={route.securityKey}
                  />
                </ProtectedRoute>
              }
            />
          ))}

          <Route path="/login" name="Login" element={<Login />} />
          <Route path="/forgot-password" name="Forgot Password" element={<ForgotPassword />} />
          <Route path="/reset-password/:email" name="Reset Password" element={<ResetPassword />} />
          <Route path="/candidate-assessment/invite/:token" name="Candidate Assessment Invite" element={<PublicCandidateAssessment />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

AppRoutes.propTypes = {
  componentRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired,
      securityKey: PropTypes.string,
    })
  ).isRequired,
};

export default AppRoutes;
